<template>
    <div :style="{ backgroundColor: backgroundColor?.hex }" class="flex py-10 lg:py-20">
        <div class="boxed-text flex flex-col md:flex-row lg:space-x-14">
            <NuxtImg
                :src="useImageUrl(image.asset._ref).url()"
                :alt="image.alt"
                class="mx-auto mr-4 object-cover md:max-w-96"
                width="384"
                height="384"
                loading="lazy"
                sizes="(max-width: 480px) 100vw, (max-width: 767px) 50vw , (min-width: 1000px) 30vw, 400px" />
            <div class="flex h-full flex-col justify-between">
                <div>
                    <h2 v-if="title" class="my-5 md:mt-0 lg:w-3/5">
                        {{ title }}
                    </h2>
                    <p v-if="text" class="mb-5 tracking-[0.65px] lg:tracking-wider">
                        {{ text }}
                    </p>
                </div>
                <Button :text="button.text" :link="'/' + getUrl(button)" class="w-max" :type="button.type"> </Button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps({
        title: String,
        text: String,
        button: Object,
        image: Object,
        backgroundColor: Object,
    });

    let buttonText = ref(props.button.text);
    const buttonData = ref();

    if (props.button.title) {
        buttonData.value = await useGetSeoUrl(props.button.internalLink._ref);
    }

    function getUrl(item: object) {
        if (item) {
            if (item.buttonType === 'external') {
                return item.externalUrl;
            } else if (item.buttonType === 'internal') {
                return buttonData[0]?.seoUrls[0]?.seoPathInfo.toLowerCase();
            } else {
                return '#';
            }
        }
    }
</script>
